import { tv } from '@otomoro/helpers/mergeClasses'
import { VariantProps } from 'tailwind-variants'

export const contentBlocksClasses = tv({
	slots: {
		base: '2xl:max-w-[172rem] 2xl:mx-auto',
		grid: 'px-2 md:px-4 grid grid-cols-4 sm:grid-cols-6 gap-x-2 md:gap-x-4 gap-y-3 md:gap-y-6',
		textCell: 'col-span-4 sm:col-span-3 md:col-span-2 border-t border-black pt-2',
		emptyTextCell: 'hidden md:block md:col-span-4 md:col-span-2 md:pt-2',
		bodyText: 'mt-1',
		listStyle: 'mt-1',
		listItemStyle:
			'mt-[0.8rem] flex before:w-[0.5rem] before:h-[0.5rem] before:rounded-full before:bg-black before:content-normal before:block relative before:absolute before:top-[0.8rem]',
		listItemText: 'pl-[1.5rem]',
	},
	variants: {
		mt: {
			true: {
				grid: 'mt-2 md:mt-4',
			},
		},
	},
})

export type ContentBlocksVariants = VariantProps<typeof contentBlocksClasses>
